import React from "react";
import { NavLink } from "react-router-dom";
import { Grid, Card, Chip, Stack, Button, FormLabel, ListItemText, ListItem, List } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import TaskAltIcon from '@mui/icons-material/TaskAlt';

type ProductProps = {
  name: string;
  label: string;
  priceInfo: string;
  price: string;
  interval?: string;
  cta: string;
  features: Array<string>;
  url: string;
  highlight?: boolean;
};

const PricingBoxes = (props) => {
  return (
    <>
      <Grid container spacing={4} sx={{ mb: 4 }}>
        <Grid size={{xs: 12, md: 4}}>
          <PricingBox
            name="Startup"
            label="All our premium features. For free."
            priceInfo="No credit card required."
            price={"$ 0"}
            interval="month"
            cta="Try now"
            features={[
              "Store unlimited lessons learned",
              "Up to 5 active users per month",
              "Up to 1,000 requests",
            ]}
            url="/signup"
          />
        </Grid>

        <Grid size={{xs: 12, md: 4}}>
          <PricingBox
            name="Medium Sized Business"
            label="The best choice for high performing teams."
            priceInfo="Starting from"
            price={"$ 49.90"}
            interval="month"
            cta="Get started"
            features={[
              "Customer support",
              "Individual team size",
              "Unlimited requests",
            ]}
            url="/signup"
            highlight
          />
        </Grid>

        <Grid size={{xs: 12, md: 4}}>
          <PricingBox
            name="Enterprise"
            label="Enterprise-level power. Talk to us to build your plan."
            priceInfo="Ask us for"
            price={"Individual"}
            cta="Talk to sales"
            features={[
              "Customizable plans",
              "Enterprise controls",
              "Setup support",
            ]}
            url="https://calendly.com/office-lessonice/demo"
          />
        </Grid>
      </Grid>

      <p className="text-center text-secondary">Prices do not include applicable taxes.</p>

    </>
  );
};

const PricingBox = (props: ProductProps) => {
  return (
    <Card>
      <Stack spacing={2}>
        <Stack spacing={1} direction="row" sx={{ alignItems: "center" }}>
          <h2>{props.name}</h2>
        </Stack>
        <p className="text-secondary">{props.label}</p>
        <FormLabel sx={{pt: 2}}>{props.priceInfo}</FormLabel>
        <h2>
          <span className="text-lg">{props.price}</span>
          {props.interval && (
            <>
              {" "}
              <span className="text-secondary">/{props.interval}</span>
            </>
          )}
        </h2>

        <Button
          variant="outlined"
          color={props.highlight ? "primary" : "secondary"}
          endIcon={<ArrowRightAltIcon />}
          component={NavLink}
          to={props.url}
        >
          {props.cta}
        </Button>

        <List>
          {props.features.map((feature) => <ListItem>
            <ListItemText>
              <TaskAltIcon fontSize="small" color="success" sx={{verticalAlign: "-0.25rem" }} /> {feature}
            </ListItemText>
          </ListItem>)}
        </List>
      </Stack>
    </Card>
  );
};

export default PricingBoxes;
